import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import posed from 'react-pose';
import FontAwesome from 'react-fontawesome';
import { authInput, authLogout, resetPassword, sendEmailChangeEmail, updateUserName } from '../store/actions';
import './radio.css';

const StyledDivContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr
  grid-template-rows: repeat(5, 3rem);
  justify-content: center;
`;

const StyledDivSubContainer = styled.div`
  margin-top: 20px;
  display: grid;
  grid-template-columns: 22rem;
  grid-auto-rows: 1fr;
`;

const StyledDivOptionContianer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(6, 2rem 1rm);
`;

const Line = styled.hr`
  border: 0;
  width: 100%;
  border-top: 1px solid #e3e3e3;
`;

const StyledIconNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const StyledHelloNameContainer = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
`;
const UserIconDiv = styled.div`
  height: 50px;
  width: 50px;
  border-radius: 50%;
  border: solid 2px white;
  text-align: center;
  background-color: white;
  margin: 1rem;
`;

const EditSectionconfig = {
  visible: { opacity: 1, scale: 1 },
  hidden: { opacity: 0, scale: 0 },

  transition: { duration: 0 },
};

const PosedEditBox = posed.div(EditSectionconfig);

const StyledInputDivContainer = styled(PosedEditBox)`
  display: ${props => props.show};
  grid-template-columns: 1fr;
  justify-content: center;
  margin-top: 2rem;
  margin-bottom: 2rem;
  height: 19git addrem;
`;
const StyledInputDiv = styled.div`
  // background-color: grey;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1rem 4rem 4rem 4rem 4rem;
  grid-gap: 1rem;
`;

const SearchInput = styled.input`
  margin: 0;
  padding: 0;
  width: 22rem;
  height: 3rem;
  border-radius: 3rem;
  border: none;
  text-indent: 1rem
  font-size: 1.5rem;
  &:focus {
    outline: none;
  }
  @media (max-width: 700px) {
    width: 18rem;
    }
`;

const ResetPasswordButton = styled.button`
  opacity: ${props => props.opacity};
  disabled: true;
  margin: 0;
  padding: 0;
  width: 22rem;
  height: 3rem;
  border-radius: 3rem;
  border: none;
  font-size: 1.5rem;
  transition: all 0.5s;
  &:focus {
    outline: none;
  }
  @media (max-width: 700px) {
    width: 18rem;
  }
  &:hover {
    opacity: 0.5;
  }
  &:active {
    background-color: red;
  }
`;
const ContactSection = styled.div`
  display: flex;
  flex-direction: row;
  align-content: center;
`;

const ContactSectionRight = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: space-between;
`;

const UserIcon = styled(FontAwesome)`
  font-size: 2rem;
  line-height: 3rem;
  color: black;
`;

const ContactIcon = styled(FontAwesome)`
  font-size: 1rem;
  line-height: 1.3rem;
  margin-left: 0.6rem;
`;

const FilterSearchButton = styled.button`
  top: 2rem;
  position: relative;
  height: 3.2rem;
  width: 3.2rem;
  border-radius: 5rem;
  background-color: red;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  justify-self: center;
  border: none;
  transition: all 0.5s;
  &::after {
    content: 'X';
    color: white;
    font-size: 1rem;
  }
  &:focus {
    outline: none;
  }
  &:hover {
    opacity: 0.5;
    cursor: pointer;
  }
  }
`;

const BodyText = styled.p`
  font-family: 'Open Sans', sans-serif;
  color: ${props => props.color};
  font-size: 1rem;
  line-height: 0rem;
  margin: 0.7rem;
`;

// const BodyTextSave = styled.p`
//   font-family: 'Open Sans', sans-serif;
//   color: ${props => props.color};
//   font-size: 1rem;
//   line-height: 0rem;
//   margin: 0.7rem;
//   &:hover {
//     cursor: pointer;
//     text-decoration: underline;
//   }
// `;

const StyledAnchor = styled.a`
  font-family: 'Open Sans', sans-serif;
  color: ${props => props.color};
  font-size: 1rem;
  line-height: 0rem;
  margin: 0.7rem;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

const StyledInputLabel = styled.label`
  margin-left: 1rem;
  padding: 0;
`;

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = { radio: 'sure', showEdit: true };
  }

  _sendPasswordReset = () => {
    if (!this.state.passwordResetPending) {
      this.props.resetPassword();
    }
  };

  _sendChangeEmailVerification = () => {
    if (!this.state.changeEmailVerificationRequestPending) {
      this.props.sendEmailChangeEmail();
    }
  };

  _showEmailPasswordEdit = () => {
    this.setState({ showEdit: !this.state.showEdit });
  };

  render() {
    const { closeModal, authLogout, auth, updateUserName } = this.props;

    return (
      <StyledDivContainer>
        <StyledDivSubContainer>
          <StyledDivOptionContianer>
            <StyledIconNameContainer>
              <UserIconDiv onClick={this.toggleModal}>
                <UserIcon name="fas fa-user" />
              </UserIconDiv>
              <StyledHelloNameContainer>
                <BodyText>Hello,</BodyText>
                <BodyText>{auth.userProfile ? `@${auth.userProfile.userName}` : ' '}</BodyText>
              </StyledHelloNameContainer>
            </StyledIconNameContainer>
            <ContactSectionRight>
              <BodyText>Edit my profile</BodyText>
              <ContactSection>
                {/* <BodyTextSave
                  color={auth.userName ? 'white' : '#939598'}
                  onClick={auth.userName ? updateUserName : null}
                >
                  Save Username
                </BodyTextSave> */}
                <ContactIcon
                  name={this.state.showEdit ? 'fas fa-sort-up' : 'fas fa-sort-down'}
                  onClick={this._showEmailPasswordEdit}
                />
              </ContactSection>
            </ContactSectionRight>
            <StyledInputDivContainer
              pose={this.state.showEdit ? 'visible' : 'hidden'}
              show={this.state.showEdit ? 'grid' : 'none'}
            >
              <StyledInputDiv>
                <StyledInputLabel htmlFor="userName">New Username</StyledInputLabel>
                <SearchInput
                  name="userName"
                  id="userName"
                  placeholder="User Name"
                  onChange={this.props.authInput}
                  value={this.props.auth.userName}
                  // onKeyPress={this._handleEnterButton}
                />
                <ResetPasswordButton
                  disabled={this.props.auth.changeEmailVerificationRequestPending ? 'disabled' : ''}
                  opacity={!this.props.auth.userName ? '0.5' : '1'}
                  onClick={auth.userName ? updateUserName : null}
                >
                  Save New Username
                </ResetPasswordButton>
                <ResetPasswordButton
                  disabled={this.props.auth.changeEmailVerificationRequestPending ? 'disabled' : ''}
                  onClick={this._sendChangeEmailVerification}
                >
                  Change My E-mail
                </ResetPasswordButton>
                <ResetPasswordButton
                  disabled={this.props.auth.passwordResetPending ? 'disabled' : ''}
                  onClick={this._sendPasswordReset}
                >
                  {this.props.auth.passwordResetEmailSent ? 'Check Your Email' : 'Reset My Password'}
                </ResetPasswordButton>
              </StyledInputDiv>
            </StyledInputDivContainer>
            <Line />
            <ContactSection>
              <ContactIcon name="fas fa-paper-plane" />
              <StyledAnchor href="mailto:cue@djcoolhand.com">Contact Us</StyledAnchor>
            </ContactSection>
            <Line />
            <StyledAnchor onClick={authLogout}>Sign Out</StyledAnchor>
            <Line />
          </StyledDivOptionContianer>
          <FilterSearchButton type="button" onClick={closeModal} />
        </StyledDivSubContainer>
      </StyledDivContainer>
    );
  }
}

const mapStateToProps = state => ({
  music: state.music,
  auth: state.auth,
});

export default connect(
  mapStateToProps,
  { authInput, authLogout, resetPassword, sendEmailChangeEmail, updateUserName }
)(Profile);



// WEBPACK FOOTER //
// ./src/components/Profile.js